import { Text } from "@chakra-ui/react";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import PlaidConnect from "../PlaidConnect";
import WidgetBox from "../WidgetBox/widget-box";
import RoleWrapper from "../RoleWrapper";
import { useFeatures } from "hooks/useFeatures";

const BankAccountBalance = () => {
  const { user } = useTenant();
  const { hasFeature } = useFeatures();
  if (!hasFeature("connect_bank_accounts")) return null;

  return (
    <RoleWrapper permissions="read_bank_accounts">
      <WidgetBox title="Bank Accounts">
        <Text fontSize="14px" mb="24px">
          {user.type === "borrower"
            ? "Connect your bank account for asset verification."
            : "Connect your bank accounts to unlock cash flow analytics."}
        </Text>
        <PlaidConnect />
        <Text fontSize="12px" mt="12px" textAlign="center">
          Connections are managed securely by{" "}
          <a href="https://plaid.com" target="_blank" rel="noreferrer noopener">
            Plaid
          </a>
          . 🔒
        </Text>
      </WidgetBox>
    </RoleWrapper>
  );
};

export default BankAccountBalance;
